import React, { useState } from 'react';
import TitleSection from 'components/common/TitleSection';
import CommonTab from 'components/common/tabs';
import TabsListing from 'components/common/tabs/TabsListing';
import {
  coperativeData,
  privateBirthdayData,
  entertainmentData,
  privateCardData,
  corporativeCardData,
  entertainmentCardData,
} from 'helpers/portfolioHelper';

const SuccessStoriesTab = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'Success stories',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const [currentTab, setCurrentTab] = useState('corporative');

  let [tabList] = useState([
    {
      id: 1,
      name: 'corporative',
      component: (
        <TabsListing
          list={coperativeData.slice(1, 6)}
          cardData={corporativeCardData}
        />
      ),
    },
    {
      id: 2,
      name: 'entertainment',
      component: (
        <TabsListing
          list={entertainmentData.slice(1, 6)}
          cardData={entertainmentCardData}
        />
      ),
    },
    {
      id: 3,
      name: 'private',
      component: (
        <TabsListing
          list={privateBirthdayData.slice(1, 6)}
          cardData={privateCardData}
        />
      ),
    },
  ]);
  return (
    <>
      <section className='portfolioPage DBlock relative py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
        <div className='max-w-7xl mx-auto'>
          <div>
            <TitleSection titleDetail={titleDetail} />
            <CommonTab
              tabList={tabList}
              setCurrentTab={setCurrentTab}
              currentTab={currentTab}
              maxWidth='max-w-xl'
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default SuccessStoriesTab;
